export default __webpack_public_path__ + "static/media/smiley3-filled.1eae6f29.svg";